import { memo, useContext, useState, useEffect, useCallback } from "react";
import navBarStyle from "../styles/nav.module.scss";
import { MaterialContext } from "../context/MaterialContext";
import { closeIcon } from "./Icons";
import { useLocation, useNavigate } from "react-router-dom";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return debouncedValue;
}

function SearchBar() {
  const { search, changeSearch } = useContext(MaterialContext);
  const [searchTerm, setSearchTerm] = useState(search || "");
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setSearchTerm(search || "");
  }, [search]);

  useEffect(() => {
    changeSearch(debouncedSearchTerm);
  }, [debouncedSearchTerm, changeSearch]);

  const handleSearch = useCallback(
    (e) => {
      if (location.pathname === "/library") {
        setSearchTerm(e.target.value);
      } else {
        navigate("/library");
        setSearchTerm(e.target.value);
      }
    },
    [location.pathname, navigate],
  );

  const handleClear = useCallback(() => {
    changeSearch("");
    setSearchTerm("");
  }, [changeSearch]);

  return (
    <div className={navBarStyle.search}>
      <input
        id="searchbar"
        name="searchbar-material"
        type="text"
        placeholder="search"
        value={searchTerm}
        onChange={handleSearch}
      />
      {search && (
        <span className={navBarStyle.clearSearch} onClick={handleClear}>
          {closeIcon}
        </span>
      )}
    </div>
  );
}

export default memo(SearchBar);
